
import { useState, useEffect } from "react";
import Grafica from '../../componentes/Grafica'
import clienteAxios from "../../axios";
import Dasboard from "../dasboard/dashboard";
import Cargador from "../../componentes/Cargador";

const GraficasPremios = () => {

  const [totalEncuesta, setTotalEncuesta] = useState(0);
  const [premios, setPremios] = useState([]);
  const [GraficaPremios, setGraficaPremios] = useState([]);
  const [cargador, setCargador] = useState(false);
 




  useEffect(() => {
    const fetchData = async () => {
      await consultarPreguntas();
    };
    fetchData();
  }, []);



  const consultarPreguntas = async () => {
    const config = { "Content-Type": "application/json" }
    const op = { "sp": "graficas", "op": "preguntas" }
    try {
      setCargador(true);
      const result = await clienteAxios.post("/api/sp", op, config);
      setPremios(result.data.data[2]);
      let total_premios=0;
      const datos = result.data.data[3].reduce((acc, element) => {
        const { premio, total } = element;

        if (!acc[premio]) {
          acc[premio] = 0;
        }
        acc[premio] += total;
         total_premios += total;
        return acc;
      }, {});
      setGraficaPremios(datos);
      setTotalEncuesta(total_premios)
    } catch (error) {
      console.error("Error al consultar preguntas:", error);
    }
    finally {
      setCargador(false);
    }
  };




  const ventas = {
    labels: Object.keys(GraficaPremios),
    datasets: [
      {
        label: 'Opiniones',
        data: Object.values(GraficaPremios),
        backgroundColor: '#3B82F6',
        borderColor: '#2563EB',
        borderWidth: 2,
      },
    ],
  };

  const options = {
    responsive: true,
    plugins: {
      legend: {
        position: 'top',
      },
      title: {
        display: true,
        text: "Premios",
      },
      datalabels: {
        color: "black",
        anchor: "end",
        align: "top",
        font: {
          weight: "bold",
        }
      }
    }
  };

  return (
    <>
      <div className="min-h-full">

        <Dasboard />
        <main className="-mt-32">
          <div className="mx-auto max-w-7xl sm:px-4 lg:px-8 min-h-screen">
            <div className="rounded-lg bg-white px-5 py-6 shadow sm:px-6  overflow-hidden min-h-screen" >
              <h2 className="text-3xl font-bold text-center mb-6 mt-4">Resultados Premios</h2>
              <p className="text-center my-4">Gráficas de premios otorgados.</p>

              {cargador && <Cargador />}             
              <div className='py-4 p-4'>
                {premios &&
                  <>
                    <h1 className="p-4 font-bold my-4">Total de encuestas: {totalEncuesta}</h1>
                    <Grafica ventas={ventas} options={options} />
                  </>
                }
                <div className="overflow-y-scroll my-4 min-h-screen ">
                  <ul className="py-4">
                    {premios.map((premio, index) => (
                      <li key={index} className="py-2 md:flex bg-blue-200 my-2 p-4 rounded-2xl w-full">
                        <div className="w-full bg-blue-200 md:text-2xl font-bold">
                          <span className="text-black pt-4">{premio.correo}</span>
                          <p className="text-blue-600 pt-2">{premio.createAd.split("T")[0]} </p>
                        </div>
                        <div className="sm:w-full md:w-1/2 font-bold text-right">
                          <span className="px-4">{premio.premio} </span>
                          <img src={premio.imagen} alt={premio.premio} className="inline-block h-24 rounded-full ml-2 p-2" />
                        </div>
                      </li>
                    ))}
                  </ul>
                </div>
              </div>
            </div>
          </div>
        </main>
      </div>
    </>
  );
};

export default GraficasPremios;